import React from 'react'
import { TranslateContext } from '../../../TranslateContext'
import InputField from '../../../../../commonComponents/formComponents/inputField'

const FreeText = (props) => {
    const { fieldName: { key, text, value }, fieldValue, setFieldValue } = props
    const translate = React.useContext(TranslateContext).translate
    return (
        <InputField
            isLabel={false}
            id={`${key}`}
            type='text'
            label={translate(`${text}`, { ns: ['default', `${text}`] })}
            className={'field-bg'}
            clearInput={false}
            value={fieldValue}
            disabled={!value?.trim()}
            onChange={(value) => {
                console.log("first___")
                setFieldValue(value)
            }}
        // onBlur={(value) => {
        //     dispatch(saveItemHeaderData('grossWeight'))
        // }}
        />
    )
}

export default FreeText